import DashboardCard from '../dashboard/DashboardStatCard';
import {
    Stack, Grid, Box
} from '@mui/material';

import React from 'react';
import { AdminApi } from '../../api/AdminApi';


const useMockData = false;
const getMockData = () => {
    return {
        "year": "2024",
        "year_stat": {
            "participant_count": 6113,
            "unique_participant_count": 685,
            "play_duration": 150660
        },
        "today_stat": {
            "participant_count": 0,
            "unique_participant_count": 0,
            "play_duration": 0
        }
    };
};

const secondToHourStr = (seconds) => {
    let hours = (seconds / 3600).toFixed(1);
    return `${hours}`;
}

const createDashboardData = (resultData) => {
    return [
        {
            title: "總參與人次",
            value: resultData.year_stat.participant_count,
            icon: "",
            color: "#DADBBC"
        }
        , {
            title: "總參與時數",
            value: secondToHourStr(resultData.year_stat.play_duration),
            icon: "",
            color: "#EE959D"
        }
        , {
            title: "今天參與人次",
            value: resultData.today_stat.participant_count,
            icon: "",
            color: "#EAC5BC"
        }
        , {
            title: "今天參與時數",
            value: secondToHourStr(resultData.today_stat.play_duration),
            icon: "",
            color: "#925B60"
        }
    ];
}


// const OrgStatDashboardData = ({  }) => {
export default function OrgStatDashboardData({ orgId, year, startMonth = 9 }) {
    const [dashboardData, setDashboardData] = React.useState(null);


    React.useEffect(() => {
        if (orgId == undefined || year == undefined || startMonth == undefined) {
            return;
        }

        console.debug("OrgStatDashboardData: loadData for orgId=", orgId,
            " year=", year, " startMonth=", startMonth);

        // if (orgID !== undefined && orgID != null) {
        loadData(orgId, year, startMonth);
        // }

    }, [orgId, year, startMonth]);


    const loadData = async (_orgId, _year, _startMonth) => {
        // load data from api
        // for now, use mock data
        if (useMockData) {
            let data = getMockData();

            let dashboardData = createDashboardData(data);
            setDashboardData(dashboardData);
            return;
        }

        AdminApi.getOrgDashboardDataCallback(_orgId, _year, _startMonth,
            (isSuccess, msg, result) => {
                console.debug("result: isSuccess=", isSuccess,
                    " msg=", msg, " result=", result);
                if (isSuccess) {
                    let dashboardData = createDashboardData(result);
                    setDashboardData(dashboardData);
                }
            });
    }

    if (dashboardData === null) {
        return <Box>Loading...</Box>;
    }

    return (
        <Grid container spacing={2} sx={{}}>
            {/* <pre>orgId: ** {orgId} ** </pre> */}
            {dashboardData.map((data, index) => (
                <Grid item xs={6} sm={4} md={2} key={index}>
                    <DashboardCard
                        title={data.title}
                        value={data.value}
                        color={data.color}
                        icon={data.icon}
                    />
                </Grid>
            ))}
        </Grid>


        //     <DashboardCard title="Testing" value={1234} color="#abc" />
        // </Stack>
        // <div className="org-stat-dashboard-data">
        //     <h2>Organization Statistics</h2>
        //     <ul>
        //         <li>
        //             <strong>Total Users:</strong>
        //         </li>
        //         <li>
        //             <strong>Active Users:</strong>
        //         </li>
        //         <li>
        //             <strong>Inactive Users:</strong>
        //         </li>
        //         <li>
        //             <strong>Departments:</strong>
        //         </li>
        //         <li>
        //             <strong>Projects:</strong>
        //         </li>
        //     </ul>
        // </div>
    );
};

